import { LoadingState } from "molecules/loadingState/LoadingState";
import "./base.css";
import "@fontsource/darker-grotesque/700.css";

import "./common/utils/i18n.ts";
import "./style/index.css";
// --font-display (Header's page title) is Darker Grotesque, Inter fallback.
import { createRoot } from "react-dom/client";
import { StrictMode, Suspense } from "react";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { appInsightsConnectionString, auth0Domain, isStaging } from "./env";
import { App } from "./App.js";
import { FeatureFlags } from "./FeatureFlags.tsx";
import "./sentry.ts";

if (import.meta.env.PROD && appInsightsConnectionString) {
	const appInsights = new ApplicationInsights({
		config: {
			connectionString: appInsightsConnectionString,
			isBeaconApiDisabled: true, // Cross-Origin Read Blocking (CORB)
			enableCorsCorrelation: true,
			correlationHeaderExcludedDomains: [
				"*.auth0.com",
				auth0Domain,
				"*.supabase.co",
			],
			enableAutoRouteTracking: true,
			enableRequestHeaderTracking: true,
			enableResponseHeaderTracking: true,
			enableAjaxPerfTracking: true,
			enableAjaxErrorStatusText: true,
			enableUnhandledPromiseRejectionTracking: true,
		},
	});
	appInsights.loadAppInsights();
	appInsights.trackPageView(); // Establishes the current user/session/pageview
}

if ("serviceWorker" in navigator && !isStaging) {
	navigator.serviceWorker
		.register("/push-sw.js", { scope: "/" })
		.catch(() => console.warn("Push SW registration failed"));
}

const root = createRoot(document.getElementById("root")!);

const renderApp = async () => {
	if (isStaging) {
		console.warn("Mocking Exopen API requests with MSW");
		const { mockExopenApiRequests } = await import("./mocking/index.js");
		await mockExopenApiRequests();
	}

	root.render(
		<StrictMode>
			<Suspense fallback={<LoadingState />}>
				<App />
			</Suspense>
			<FeatureFlags />
		</StrictMode>,
	);
};

void renderApp();
